import { useEffect } from 'react';
import { SubpageIntro2018, SubpageLayout2018 } from '../subpageLayout';

const categories = [
  {
    title: '智慧出行',
    icon: '/2018/images/mobility.png',
    detailTitle: '「智慧出行」',
    content:
      '旨在通過基礎設施投資提高市民的流動性。總括而言，「智慧出行」包括減少污染、減少交通堵塞、提高生命安全，減少噪音污染和降低轉運成本。智慧車輛、智慧基礎設施，智慧網絡及智慧控制系統是「智慧出行」不可或缺的工具，而「智慧出行」可透過制定智能交通系統策略路線圖，在公共運輸交匯處安裝多功能傳感器，開發一體化運輸移動應用程序，使用物聯網（IoT）改善車位搜尋過程，以至在香港國際機場注入自動化概念，將其升級為智能機場。',
  },
  {
    title: '智慧生活',
    icon: '/2018/images/living.png',
    detailTitle: '「智慧生活」',
    content:
      '著重於提高個人與電子服務互動的能力。「智慧生活」的目標之一是令公眾具備信心使用電子服務，包括支付、電子認證。此外，「智慧生活」亦包括推廣老人福祉科技，長者能使用可穿戴技術監察健康狀況。「智慧生活」還包含發展智能醫院，其將有助提供預防性醫療服務和個人化醫療意見。「智慧生活」將推進改善及管理生活環境和生活質素。',
  },
  {
    title: '智慧環境',
    icon: '/2018/images/environment.png',
    detailTitle: '「智慧環境」',
    content:
      '改變政府管理人造和自然環境的方法，目的是實現透過「減少」、「再用」和「循環再造」最大程度優化城市資源的使用，即促進綠色和智能建築，用智慧技術管理電網，提高廢物管理的效率，通過使用遙感器加強污染管理，和提高商業環境中的能源效率等，代表著不但利用傳感器技術、行為經濟學和遊戲化技術改變基礎設施，更鼓勵積極的資源決策。',
  },
  {
    title: '智慧市民',
    icon: '/2018/images/people.png',
    detailTitle: '「智慧市民」',
    content:
      '旨在改變人們獲取公共和私營服務的方式，並促進終身學習，引伸的領域包括提升香港數據科學能力，基於「一站式城市服務」提供方便的公共服務，利用不同的互聯網工具和社交媒體解構公眾意見，以及通過教育培養創業、創新精神等，與此同時，繼續於銀髮族間推動訊息通訊技術的應用，鼓勵針對銀髮族需要的訊息通訊技術創新。預計「智慧市民」的推行可驅使香港市民透過網上及其他平台參與公共事務。',
  },
  {
    title: '智慧政府',
    icon: '/2018/images/government.png',
    detailTitle: '「智慧政府」',
    content:
      '透過相關基礎設施整理、分析、展示城市數據以服務持份者，換言之，可能需要徹底改革後端流程、決策制定，以及訊息流、實施。「智慧政府」擔當主導角色，部署5G流動通訊技術、在社區安裝多功能智慧桿、建立虛擬三維模擬平台，且提供更多以市民為中心的電子服務。此外，「智慧政府」率先提高政府的數據分析能力，以及整合在適當地點的電力，供水和下水道管道等。',
  },
  {
    title: '智慧經濟',
    icon: '/2018/images/economy.png',
    detailTitle: '「智慧經濟」',
    content:
      '涵蓋改善香港的營商環境，促進金融科技發展，實踐再工業化，以及為初創企業和投資者締造更理想的城市環境，務求強化香港經濟。「智慧經濟」聚焦於促進香港再工業化，尤其機械人、物聯網、無人機、三維打印，人工智能和分析等新興技術，其將應用於打造高增值製造業。智慧旅遊將在智慧經濟的發展下作出貢獻，即利用智慧創新技術令遊客與城市的互動變得更順暢，為他們導航和尋找服務、規劃行程，提升整體香港旅遊體驗。',
  },
] as const;

const benefits = [
  '得獎者名單將刊登於「香港智慧城市峰會暨智慧城市大獎2018」之網站',
  '大獎具認受性，得獎者將被譽為業界精英，能力與成就為大眾認可',
  '得獎者可授權於自己的網站和宣傳材料上展示得獎標誌',
  '廣泛的跨平台媒體報導有助公司宣傳',
  '有助得獎者於多方面取得正面宣傳與效益，包括品牌關注度、銷售及員工士氣等',
  '獲10多個專業團體支持，得獎者將由10多名專家組成的獨立評審團嚴格選出',
  '由主要傳媒合作夥伴及作為行業翹楚的贊助者鼎力支持',
] as const;

export default function Awards2018Zh() {
  useEffect(() => {
    const acc = Array.from(document.getElementsByClassName('accordion')) as HTMLElement[];
    const handlers: Array<() => void> = [];
    acc.forEach((btn) => {
      const handler = () => {
        btn.classList.toggle('active');
        const panel = btn.nextElementSibling as HTMLElement | null;
        if (!panel) return;
        panel.style.maxHeight = panel.style.maxHeight ? '' : `${panel.scrollHeight}px`;
      };
      btn.addEventListener('click', handler);
      handlers.push(() => btn.removeEventListener('click', handler));
    });
    return () => handlers.forEach((off) => off());
  }, []);

  return (
    <SubpageLayout2018 lang="zh" title="得獎類別" page="awards">
      <div className="award_categories">
        <SubpageIntro2018
          heading="獎項"
          intro="「香港智慧城市大獎 2018」的6個比賽組別相等於《香港智慧城市藍圖顧問研究報告》中的6個智慧範疇，大獎的組別擁有各自的獎項名稱，每個獎項彰顯得獎者對所屬行業的特定貢獻。比賽組別包括："
        />
        <div className="accordion_container">
          {categories.map((c, idx) => (
            <div key={c.title}>
              <button
                className="accordion animate"
                data-animate="flipInX"
                data-duration="1.0s"
                data-delay={`0.${idx + 1}s`}
                data-offset="100"
              >
                <div className="accordion_icons">
                  <img src={c.icon} alt="" />
                </div>
                {c.title}
              </button>
              <div className="panel">
                <p>
                  <span style={{ fontSize: 23 }}>{c.detailTitle}</span> {c.content}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="benefits">
        <div className="benefits_container">
          <div className="benefits_title">得獎者的裨益</div>
          <div className="benefits_text_container animate" data-animate="fadeIn" data-duration="1.5s" data-delay="0.1s" data-offset="100">
            {benefits.map((text, idx) => (
              <div key={text} className={`benefits_text b${idx + 1}`}>
                {text}
                <div className="corner">
                  <img src="/2018/images/corner.png" alt="" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SubpageLayout2018>
  );
}

